"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
require("../../../../src/app.css");
var config_1 = require("../../../constants/config");
var styles_1 = require("../../styles");
var navigationWarning_1 = require("../../../services/navigationWarning");
function ModalWindow(props) {
    var _this = this;
    // State management for audio and call status
    var _a = (0, react_1.useState)(null), micStream = _a[0], setMicStream = _a[1];
    var _b = (0, react_1.useState)(null), audioMotion = _b[0], setAudioMotion = _b[1];
    var _c = (0, react_1.useState)(false), isCalling = _c[0], setIsCalling = _c[1];
    var _d = (0, react_1.useState)(false), isTransferActive = _d[0], setTransferActive = _d[1];
    var _e = (0, react_1.useState)([]), chatData = _e[0], setChatData = _e[1];
    var widgetConfig = (0, config_1.getWidgetConfig)();
    var _f = (0, react_1.useState)(widgetConfig.agentName), currentAgentName = _f[0], setCurrentAgentName = _f[1];
    var _g = (0, react_1.useState)(widgetConfig.agentId), currentAgentId = _g[0], setCurrentAgentId = _g[1];
    var _h = (0, react_1.useState)(false), hasStartedInitialCall = _h[0], setHasStartedInitialCall = _h[1];
    var _j = (0, react_1.useState)(true), canMakeCall = _j[0], setCanMakeCall = _j[1];
    var _k = (0, react_1.useState)(0), callCount = _k[0], setCallCount = _k[1];
    var _l = (0, react_1.useState)(false), startingCall = _l[0], setstartingCall = _l[1];
    var _m = (0, react_1.useState)(null), callLimitError = _m[0], setCallLimitError = _m[1];
    // Refs for maintaining state between renders
    var agentLastQuestion = (0, react_1.useRef)("");
    var chatContainerRef = (0, react_1.useRef)(null);
    var _o = (0, react_1.useState)(null), micAccess = _o[0], setMicAccess = _o[1];
    var transferTriggeredRef = (0, react_1.useRef)(false);
    var holdMusicRef = (0, react_1.useRef)(null);
    var handleUpdateCounter = (0, react_1.useRef)(0);
    // User data storage
    var userData = (0, react_1.useRef)({
        first_name: "",
        last_name: "",
        phone_number: "",
        customer_email: ""
    });
    // Initialize AI Agent SDK
    var agentSDK = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(function () {
        // Load the AI Agent SDK script
        if (!window.AIAgentSDK) {
            var script = document.createElement('script');
            script.src = '/ai-agent-sdk.js';
            script.async = true;
            script.onload = function () {
                console.log('AI Agent SDK loaded successfully');
            };
            document.head.appendChild(script);
        }
    }, []);
    // Hold music management functions
    var playHoldMusic = function () {
        if (!holdMusicRef.current) {
            var audio = new Audio('/Jazz.mp3');
            audio.loop = true;
            audio.volume = 0.5;
            holdMusicRef.current = audio;
        }
        holdMusicRef.current.play().catch(console.error);
    };
    var stopHoldMusic = function () {
        var _a;
        (_a = holdMusicRef.current) === null || _a === void 0 ? void 0 : _a.pause();
        if (holdMusicRef.current)
            holdMusicRef.current.currentTime = 0;
    };
    // Utility function for delays
    var wait = function (ms) { return new Promise(function (resolve) { return setTimeout(resolve, ms); }); };
    // Function to start a call with AI Agent SDK
    function startCall(agentId_1) {
        return __awaiter(this, arguments, void 0, function (agentId, context) {
            var trackingData, err_1, err_2;
            var _a, _b;
            var _c, _d, _e, _f;
            if (context === void 0) { context = {}; }
            return __generator(this, function (_g) {
                switch (_g.label) {
                    case 0:
                        _g.trys.push([0, 10, , 11]);
                        setstartingCall(true);
                        _a = {
                            sourceId: widgetConfig.sourceId,
                            timestamp: Date.now()
                        };
                        _b = {
                            widgetId: widgetConfig.widgetId,
                            userId: widgetConfig.userId,
                            usageType: widgetConfig.type,
                            origin: window.location.origin,
                            userAgent: navigator.userAgent,
                            referrer: document.referrer,
                            screenResolution: "".concat(window.screen.width, "x").concat(window.screen.height),
                            colorDepth: String(window.screen.colorDepth),
                            timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
                            language: navigator.language,
                            cookiesEnabled: navigator.cookieEnabled,
                            doNotTrack: navigator.doNotTrack
                        };
                        return [4 /*yield*/, fetch('https://api.ipify.org?format=json')
                                .then(function (response) { return response.json(); })
                                .then(function (data) { return data.ip; })
                                .catch(function () { return 'unknown'; })];
                    case 1:
                        _b.ipAddress = _g.sent();
                        return [4 /*yield*/, fetch('https://ipapi.co/json/')
                                .then(function (response) { return response.json(); })
                                .then(function (data) { return "".concat(data.city, ", ").concat(data.region, ", ").concat(data.country_name); })
                                .catch(function () { return 'unknown'; })];
                    case 2:
                        _b.location = _g.sent(),
                            _b.sessionId = crypto.randomUUID(),
                            _b.timestamp = new Date().toISOString(),
                            _b.connectionType = ((_c = navigator.connection) === null || _c === void 0 ? void 0 : _c.type) || 'unknown',
                            _b.connectionSpeed = String(((_d = navigator.connection) === null || _d === void 0 ? void 0 : _d.downlink) || 'unknown'),
                            _b.memory = String(navigator.deviceMemory || 'unknown'),
                            _b.hardwareConcurrency = String(navigator.hardwareConcurrency || 'unknown');
                        return [4 /*yield*/, ((_f = (_e = navigator).getBattery) === null || _f === void 0 ? void 0 : _f.call(_e).then(function (battery) { return ({
                                charging: battery.charging,
                                level: battery.level,
                                chargingTime: battery.chargingTime,
                                dischargingTime: battery.dischargingTime
                            }); }).catch(function () { return 'unknown'; }))];
                    case 3:
                        _b.batteryStatus = _g.sent();
                        return [4 /*yield*/, Promise.all([
                                navigator.permissions.query({ name: 'microphone' }),
                                navigator.permissions.query({ name: 'camera' }),
                                navigator.permissions.query({ name: 'notifications' })
                            ]).then(function (_a) {
                                var mic = _a[0], cam = _a[1], notif = _a[2];
                                return ({
                                    microphone: mic.state,
                                    camera: cam.state,
                                    notifications: notif.state
                                });
                            }).catch(function () { return 'unknown'; })];
                    case 4:
                        trackingData = (_a.metadata = (_b.permissions = _g.sent(),
                            _b.deviceInfo = {
                                platform: navigator.platform,
                                vendor: navigator.vendor,
                                mobile: /Mobile|Android|iP(hone|od)|IEMobile|BlackBerry|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(navigator.userAgent),
                                browser: {
                                    name: navigator.appName,
                                    version: navigator.appVersion
                                }
                            },
                            _b),
                            _a);
                        _g.label = 5;
                    case 5:
                        _g.trys.push([5, 7, , 8]);
                        return [4 /*yield*/, fetch("https://theconnexus.ai/agent/widgetCalls", {
                                method: "POST",
                                headers: {
                                    'Authorization': 'Bearer 1b07e2d1-c19f-44de-a638-303e755e1477',
                                    'Content-Type': 'application/json',
                                    'x-retell-signature': '1b07e2d1-c19f-44de-a638-303e755e1477',
                                },
                                body: JSON.stringify({
                                    agent_id: agentId,
                                    metadata: __assign(__assign({}, trackingData), { sourceId: widgetConfig.sourceId }),
                                    context: context
                                }),
                            })];
                    case 6:
                        _g.sent();
                        return [3 /*break*/, 8];
                    case 7:
                        err_1 = _g.sent();
                        console.error("Error saving call data:", err_1);
                        return [3 /*break*/, 8];
                    case 8:
                        // Initialize AI Agent SDK if not already done
                        if (!agentSDK.current && window.AIAgentSDK) {
                            agentSDK.current = new window.AIAgentSDK({
                                agentId: agentId,
                                mode: 'voice'
                            });
                            // Set up event handlers
                            agentSDK.current
                                .on('connected', handleCallStarted)
                                .on('disconnected', handleCallEnded)
                                .on('transcriptReceived', handleTranscript)
                                .on('error', handleError);
                        }
                        // Connect to the agent
                        return [4 /*yield*/, agentSDK.current.connect()];
                    case 9:
                        // Connect to the agent
                        _g.sent();
                        return [2 /*return*/, true];
                    case 10:
                        err_2 = _g.sent();
                        console.error("Call start failed:", err_2);
                        setstartingCall(false);
                        return [2 /*return*/, false];
                    case 11: return [2 /*return*/];
                }
            });
        });
    }
    // Function to handle call transfers between agents
    var transferCall = function (newAgentId, context) { return __awaiter(_this, void 0, void 0, function () {
        var success, err_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    // Prevent multiple concurrent transfers
                    if (isTransferActive) {
                        return [2 /*return*/];
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 6, , 7]);
                    console.log("Starting transfer to agent:", newAgentId);
                    setTransferActive(true);
                    if (!agentSDK.current) return [3 /*break*/, 3];
                    return [4 /*yield*/, agentSDK.current.disconnect()];
                case 2:
                    _a.sent();
                    _a.label = 3;
                case 3:
                    playHoldMusic();
                    return [4 /*yield*/, wait(1500)];
                case 4:
                    _a.sent();
                    // Update current agent
                    setCurrentAgentId(newAgentId);
                    return [4 /*yield*/, startCall(newAgentId, context)];
                case 5:
                    success = _a.sent();
                    if (!success) {
                        throw new Error('Failed to start transfer call');
                    }
                    stopHoldMusic();
                    setTransferActive(false);
                    setIsCalling(true);
                    setstartingCall(false);
                    setHasStartedInitialCall(true);
                    setCallLimitError(null);
                    props.setVisible(true);
                    transferTriggeredRef.current = false;
                    console.log("Transfer completed successfully");
                    return [3 /*break*/, 7];
                case 6:
                    err_3 = _a.sent();
                    console.error("Transfer failed:", err_3);
                    setCallLimitError('Failed to transfer call. Please try again.');
                    stopHoldMusic();
                    setTransferActive(false);
                    transferTriggeredRef.current = false;
                    return [3 /*break*/, 7];
                case 7: return [2 /*return*/];
            }
        });
    }); };
    // Function to end call and reset all states
    var endCallAndReset = function () { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    console.log("Ending call and resetting...");
                    if (!agentSDK.current) return [3 /*break*/, 2];
                    return [4 /*yield*/, agentSDK.current.disconnect()];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2:
                    setIsCalling(false);
                    setTransferActive(false);
                    setHasStartedInitialCall(false);
                    // Update navigation warning service
                    navigationWarning_1.navigationWarningService.setCallActive(false);
                    props.setVisible(false);
                    return [2 /*return*/];
            }
        });
    }); };
    // Utility function to clean and normalize text
    function cleanText(text) {
        return text.toLowerCase().replace(/[""]/g, '"').replace(/['']/g, "'").replace(/…/g, "...").replace(/[^\w\s']+$/g, '').trim();
    }
    // Function to check if transfer should be triggered based on agent's message
    function shouldTriggerTransfer(content, triggerPhrases) {
        var last = content.split(/[.!?]/).map(cleanText).filter(Boolean).pop();
        return !!last && triggerPhrases.some(function (phrase) { return last === cleanText(phrase); });
    }
    // Handler for transcript updates from AI Agent SDK
    var handleTranscript = function (data) {
        handleUpdateCounter.current++;
        console.log('Transcript received:', data);
        var segments = data.segments, isUser = data.isUser;
        if (!segments || segments.length === 0)
            return;
        // Process each segment
        segments.forEach(function (segment) {
            var role = isUser ? "user" : "agent";
            var newContent = segment.text || "";
            if (!newContent)
                return;
            debugSetChatData(function (prev) {
                var lastMessage = prev[prev.length - 1];
                // If the last message is from the same role, UPDATE it
                if ((lastMessage === null || lastMessage === void 0 ? void 0 : lastMessage.role) === role) {
                    var updatedMessage = __assign(__assign({}, lastMessage), { content: newContent });
                    return __spreadArray(__spreadArray([], prev.slice(0, -1), true), [updatedMessage], false);
                }
                // Otherwise add new message
                return __spreadArray(__spreadArray([], prev, true), [{ role: role, content: newContent }], false);
            });
            // Handle agent messages and potential transfers
            if (role === "agent" && newContent) {
                agentLastQuestion.current = newContent.toLowerCase();
                // Define trigger phrases for call transfers
                var transferExamples = [
                    "Please hold on for a moment",
                    "Please hold on for a moment while I transfer you",
                    "Please hold on for a moment while I transfer your call",
                    "Please hold on for a moment while I connect you",
                    "please hold on for just a moment"
                ];
                var shouldTransfer = shouldTriggerTransfer(newContent, transferExamples);
                if (shouldTransfer && !transferTriggeredRef.current) {
                    transferTriggeredRef.current = true;
                    // Build conversation summary
                    var summary_1 = chatData.map(function (msg) { return "".concat(msg.role, ": ").concat(msg.content); }).join("\n");
                    // Delay and trigger transfer
                    wait(3000).then(function () {
                        var _a, _b;
                        (_b = (_a = window).transferToAgent) === null || _b === void 0 ? void 0 : _b.call(_a, widgetConfig.transferAgentName);
                        transferCall(widgetConfig.transferAgentId, {
                            handoff_reason: "agent_triggered_transfer",
                            conversation_summary: summary_1,
                        });
                    });
                }
            }
            // Handle user data collection based on agent questions
            if (role === "user" && newContent) {
                if (agentLastQuestion.current.includes("your name")) {
                    var nameParts = newContent.trim().split(" ");
                    if (nameParts.length >= 2) {
                        userData.current.first_name = nameParts[0];
                        userData.current.last_name = nameParts.slice(1).join(" ");
                    }
                }
                if (agentLastQuestion.current.includes("your phone")) {
                    userData.current.phone_number = newContent.trim();
                }
                if (newContent.includes("@")) {
                    userData.current.customer_email = newContent.trim();
                }
                if (agentLastQuestion.current.includes("interests you the most")) {
                    userData.current.customer_inquiry = newContent.trim();
                }
                if (agentLastQuestion.current.includes("preferred time")) {
                    userData.current.preferred_contact_time = newContent.trim();
                }
            }
        });
    };
    // Effect to check call availability
    // useEffect(() => {
    //   const checkCallAvailability = async () => {
    //     try {
    //       const canCall = await callTrackingService.canMakeCall(
    //         widgetConfig.userId,
    //         widgetConfig.widgetId
    //       );
    //       setCanMakeCall(canCall);
    //     } catch (error) {
    //       console.error('Failed to check call availability:', error);
    //       setCanMakeCall(false);
    //     }
    //   };
    //   checkCallAvailability();
    // }, []);
    // Event handlers for AI Agent SDK
    var handleCallStarted = function () {
        console.log("📞 Call started event received");
        setIsCalling(true);
        navigationWarning_1.navigationWarningService.setCallActive(true);
    };
    var handleCallEnded = function () {
        console.log("📞 Call ended event received");
        setIsCalling(false);
        navigationWarning_1.navigationWarningService.setCallActive(false);
        props.setVisible(false);
    };
    var handleError = function (err) {
        console.error("❌ Call error:", err);
        if (agentSDK.current) {
            agentSDK.current.disconnect();
        }
        setCallLimitError(err.message || 'An error occurred during the call');
    };
    // Effect to handle initial call setup and cleanup
    (0, react_1.useEffect)(function () {
        var setupCall = function () { return __awaiter(_this, void 0, void 0, function () {
            var success, err_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(props.visible && !isTransferActive && !hasStartedInitialCall)) return [3 /*break*/, 8];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 6, , 7]);
                        if (!(isCalling && agentSDK.current)) return [3 /*break*/, 4];
                        return [4 /*yield*/, agentSDK.current.disconnect()];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, new Promise(function (resolve) { return setTimeout(resolve, 1000); })];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4: return [4 /*yield*/, startCall(currentAgentId)];
                    case 5:
                        success = _a.sent();
                        if (!success) {
                            setCallLimitError('Failed to start call. Please try again.');
                            return [2 /*return*/];
                        }
                        setHasStartedInitialCall(true);
                        setCallLimitError(null);
                        return [3 /*break*/, 7];
                    case 6:
                        err_4 = _a.sent();
                        console.error("Call setup failed:", err_4);
                        setCallLimitError('Failed to start call. Please try again.');
                        return [3 /*break*/, 7];
                    case 7: return [3 /*break*/, 9];
                    case 8:
                        if (!props.visible && isTransferActive === false) {
                            console.log("Widget closed - cleaning up call");
                            endCallAndReset();
                        }
                        _a.label = 9;
                    case 9: return [2 /*return*/];
                }
            });
        }); };
        setupCall();
    }, [props.visible]);
    // Effect to setup navigation warning service
    (0, react_1.useEffect)(function () {
        // Only setup navigation warnings for non-SPA sites
        if (!navigationWarning_1.navigationWarningService.getIsSPA()) {
            navigationWarning_1.navigationWarningService.setWarningOptions({
                onBeforeNavigate: function (targetUrl) {
                    // This will be called before navigation, but we handle it in the modal
                    return true;
                },
                onConfirmNavigate: function (targetUrl) {
                    // Open the target URL in a new tab
                    window.open(targetUrl, '_blank');
                },
                onCancelNavigate: function () {
                    // User cancelled navigation, do nothing
                    //console.log('Navigation cancelled by user');
                }
            });
        }
    }, []);
    // Effect to update navigation warning service when call status changes
    (0, react_1.useEffect)(function () {
        navigationWarning_1.navigationWarningService.setCallActive(isCalling);
    }, [isCalling]);
    // Effect to cleanup navigation warning service on unmount
    (0, react_1.useEffect)(function () {
        return function () {
            // Cleanup navigation warning service when component unmounts
            navigationWarning_1.navigationWarningService.setCallActive(false);
        };
    }, []);
    // Debug wrapper for setChatData to track all calls
    var debugSetChatData = function (value) {
        // //console.log("🐛 setChatData called with:", value);
        // console.trace("🐛 Call stack:");
        setChatData(value);
    };
    // Monitor chatData changes
    (0, react_1.useEffect)(function () {
        //console.log("🔍 ChatData changed - Length:", chatData.length, "Data:", chatData);
    }, [chatData]);
    // Render the chat interface
    return (react_1.default.createElement("div", { style: __assign(__assign({}, styles_1.styles.modalWindow), { display: false ? "block" : "none", opacity: false ? "1" : "0", transition: "opacity 0.3s ease" }) },
        react_1.default.createElement("div", { className: "chat-container", ref: chatContainerRef, style: {
                height: "56vh",
                width: "100%",
                overflowY: "auto",
                background: "#333",
                padding: "1rem",
                borderRadius: "10px",
                display: startingCall && !isCalling ? "flex" : "block",
                justifyContent: "center",
                alignItems: "center",
            } }, startingCall && !isCalling ? (react_1.default.createElement("div", { className: "loading-icon" },
            react_1.default.createElement("div", { className: "spinner" }),
            react_1.default.createElement("p", { style: { color: "#fff", marginTop: "1rem" } },
                "Connecting with ",
                currentAgentName,
                "..."))) : (react_1.default.createElement(react_1.default.Fragment, null,
            chatData.map(function (message, index) { return (react_1.default.createElement("div", { key: index, className: "chat-bubble ".concat(message.role === "agent" ? "agent" : "user") }, message.content)); }),
            isCalling && (react_1.default.createElement("button", { onClick: endCallAndReset, className: "end-call-button" },
                "End Call with ",
                currentAgentName)))))));
}
exports.default = ModalWindow;
// declare global {
//   interface Window {
//     transferToAgent?: (name: string) => void;
//   }
// }
